var swiper = new Swiper(".marquee-outerList", {
    spaceBetween: 0,
    centeredSlides: false,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
  });



document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const faqText = item.querySelector('.faq-text');
    const answer = item.querySelector('.faq-answer');
    

    const toggleAnswer = () => {
      const isExpanded = answer.style.display === 'block';
      answer.style.display = isExpanded ? 'none' : 'block';
      button.textContent = isExpanded ? '+' : '-';
    };

    faqText.addEventListener('click', toggleAnswer);
    
  });


//  const readMoreToggle = document.querySelector('[data-toggle-read-more]');
// const descriptionWrapper = document.querySelector('.product__description-wrapper');

// if (readMoreToggle && descriptionWrapper) {
//   const rightArrowSvg = `
//   <span class="arrow-icon">
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
//       <path style="fill:#232326" d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Right"/>
//     </svg>
//     </span>
//   `;

//   const downArrowSvg = `
//   <span class="arrow-icon">
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
//       <path style="fill:#232326" d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Down"/>
//     </svg>
//     </span>
//   `;

//   readMoreToggle.addEventListener('click', () => {
//     descriptionWrapper.classList.toggle('expanded');

//     if (descriptionWrapper.classList.contains('expanded')) {
//       readMoreToggle.innerHTML = 'Read Less ' + downArrowSvg;
//     } else {
//       readMoreToggle.innerHTML = 'Read More ' + rightArrowSvg;
//     }
//   });
// }

});
